import { store } from "@betacrew/jars-flux";
import { componentKey, setDownloadAllPdfModal, setFormList, setLoadingState, setPaginationState, setPayerList, setReloadResubmitGridData, setSelectedForm, setSelectedPayer, setStateResubmitGridData, setTaxYearList, setUpdateWithheldIdModal } from "./StateResubmitSlice";
import { all, put, takeLatest } from "redux-saga/effects";
import ResubmitDataService from "../../../../../services/ResubmitDataService";
import ManageFormsService from "../../../../../services/ManageFormsService";
import General from "../../../../../libs/utility/General";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import GeneralDataService from "../../../../../services/GeneralDataService";
import { TOASTER_VARIANT } from "../../../../components/toast/constants"
import { IRS_STATE_RESUBMIT_LOADING_STATES } from "../constant";

export const { getStateResubmitFormsList, getPayersList, getStateResubmitTaxYears, getStateResubmitGridData, stateResubmitViewPDF, updateStateWithHeldId, downLoadStatePDFs, reSubmitSelectedFormsToState } = {

    getStateResubmitFormsList: (payload) => {
        return {
            type: "STATE_RESUBMIT/GET_FORMS_LIST",
            payload
        }
    },

    getPayersList: (payload) => {
        return {
            type: "STATE_RESUBMIT/GET_PAYERS_LIST",
            payload
        }
    },

    getStateResubmitTaxYears: (payload) => {
        return {
            type: "STATE_RESUBMIT/GET_TAX_YEARS",
            payload
        }
    },

    getStateResubmitGridData: (payload) => {
        return {
            type: "STATE_RESUBMIT/GET_GRID_DATA",
            payload
        }
    },

    stateResubmitViewPDF: (payload) => {
        return {
            type: "STATE_RESUBMIT/VIEW_PDF",
            payload
        }
    },

    updateStateWithHeldId: (payload) => {
        return {
            type: "STATE_RESUBMIT/UPDATE_WITHHELD_ID",
            payload
        }
    },

    downLoadStatePDFs: (payload) => {
        return {
            type: "STATE_RESUBMIT/DOWNLOAD_STATE_PDF",
            payload
        }
    },
    reSubmitSelectedFormsToState: (payload) => {
        return {
            type: "STATE_RESUBMIT/RESUBMIT_SELECTED_FORMS_TO_STATE",
            payload
        }
    },

}

function* getStateResubmitFormsListAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING, message: "Fetching Data" }));

        const { formId } = action?.payload;

        const response = yield ManageFormsService.getStateForms();
        const { Message, Status, Data } = response?.data || {};

        if (Status) {
            General.addOptionAndValueKeys(Data, "FormName1", "FormId")

            if (formId) {
                const form = Data.find(r => r.FormId == formId);

                if (form) {
                    yield put(setSelectedForm(form));
                }
            }

            yield put(setFormList(Data))

        } else {
            yield put(addNotifications({ heading: "Failed to fetch the reference list", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch the reference list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* getPayersListAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING }))

        const { formId } = action.payload;
        const params = { formNameId: formId };
        const response = yield ResubmitDataService.getStateResubmitPayersList(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "LastName", "PayerDetailId")
            const payers = Data.map(item => { return { ...item, checked: false } })
            yield put(setPayerList(payers))
            yield put(setSelectedPayer({ label: "", value: "" }))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch payers list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch payers list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* getStateResubmitTaxYearsAsync() {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_YEARS_LIST_LOADING }))

        const response = yield GeneralDataService.getTaxYears()

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "ID", "ID")
            yield put(setTaxYearList(Data))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch tax year", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch tax year", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_YEARS_LIST_READY }))
    }
}

function* getStateResubmitGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }))

        const { formTypeId, payerId, formName, taxYear, PageNumber, PageSize, FilterText, IdNumber, IsDesc } = action.payload

        const params = {
            formTypeId,
            formName,
            payerId,
            taxYear,
            PageNumber,
            PageSize,
            FilterText: "",
            IdNumber: "",
            IsDesc: "",
        }

        const response = yield ResubmitDataService.getStateResubmitGridData(params);
        const { Message, Status } = response?.data;
        
        const Data = General.extractDataFromResponseData(response?.data)

        if (Status) {
            yield put(setStateResubmitGridData(Data))
            yield put(setPaginationState({ total: General.extractPaginationTotalFromResponse(response.data) }))
        } else {
            yield put(addNotifications({ heading: "Failed to get state form list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get state form list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* stateResubmitViewPDFAsync(action) {
    try {
        const { reconFormId, formName } = action.payload;
        yield put(setLoadingState({ state: `${IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${reconFormId}` }));

        const params = { reconFormId, formName };
        const response = yield ManageFormsService.getStatePDF(params);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name);
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to open the PDF", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_VIEW_PDF_LIST_READY }))
    }
}

function* updateStateWithHeldIdAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.UPDATE_WITHHELD_ID_LOADING }));

        const { CorrectedAccountNumber, StateReference, formTypeId, formId, payerId, taxYear, paginationState, formName } = action.payload;

        const params = { CorrectedAccountNumber, StateReference, formId };
        const response = yield ResubmitDataService.updateAccountNumber(params);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setUpdateWithheldIdModal(false))
            yield put(getStateResubmitGridData({ 
                formTypeId: formName, 
                formName, 
                payerId, 
                taxYear, 
                PageNumber: paginationState?.PageNumber, 
                PageSize: paginationState?.PageSize,
                FilterText: paginationState?.SearchByName,
                IdNumber: paginationState?.SearchByTIN,
                IsDesc: paginationState?.IsDesc 
            }))
        } else {
            yield put(addNotifications({ heading: "Failed to update the form", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to update the form", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.UPDATE_WITHHELD_ID_READY }))
    }
}

function* downLoadStatePDFsAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }))

        const { payerName, formName, stateName, taxYear, payerId, isRejected } = action?.payload;
        const response = yield ManageFormsService.downLoadStatePDFs({ payerName, formName, stateName, taxYear, payerId, isRejected })

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name)
            yield put(setDownloadAllPdfModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to download a PDF", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download a PDF", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* reSubmitSelectedFormsToStateAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }))

        const { data } = action.payload;
        const response = yield ResubmitDataService.resubmitToState(data)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setReloadResubmitGridData(true));
        } else {
            yield put(addNotifications({ heading: "Facing issue", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Facing issue", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getStateResubmitFormsList().type, getStateResubmitFormsListAsync),
        takeLatest(getPayersList().type, getPayersListAsync),
        takeLatest(getStateResubmitTaxYears().type, getStateResubmitTaxYearsAsync),
        takeLatest(getStateResubmitGridData().type, getStateResubmitGridDataAsync),
        takeLatest(stateResubmitViewPDF().type, stateResubmitViewPDFAsync),
        takeLatest(updateStateWithHeldId().type, updateStateWithHeldIdAsync),
        takeLatest(downLoadStatePDFs().type, downLoadStatePDFsAsync),
        takeLatest(reSubmitSelectedFormsToState().type, reSubmitSelectedFormsToStateAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);